import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function ArrowOutwardIcon(props: SvgIconProps) {
  const fill = props.fill ?? props.color ?? '#3E8FFA';
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 24 24'
    >
      <path
        d='M6 6v2h8.59L5 17.59 6.41 19 16 9.41V18h2V6z'
        fill={fill}
      />
    </SvgIcon>
  );
}
